export const guidMatch = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export default class GuidService {
  static s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  static newGuid() {
    return `${this.s4()}${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}${this.s4()}${this.s4()}`;
  }

  static isGuid(stringToCheck) {
    if (!stringToCheck || typeof stringToCheck !== 'string') {
      return false;
    }
    const match = stringToCheck.match(guidMatch);
    return match && match[0] === stringToCheck;
  }

  static getGuidRegexMatch(stringToCheck) {
    return stringToCheck?.match(guidMatch);
  }
}
